// @flow
import { OpinometroActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    opinometro: {},
    listaOpinometros: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type OpinometroAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { opinometro?: {} | null, listaOpinometros?: [] | null, loading?: boolean, +value ?: boolean };

const Opinometro = (state: State = INIT_STATE, action: OpinometroAction): any => {
    // console.log(action);
    switch (action.type) {
        case OpinometroActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OpinometroActionTypes.GET_OPINOMETRO: {
                    return {
                        ...state,
                        opinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OpinometroActionTypes.LIST_OPINOMETROS: {
                    return {
                        ...state,
                        listaOpinometros: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OpinometroActionTypes.ADD_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OpinometroActionTypes.DUPLICATE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OpinometroActionTypes.UPDATE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OpinometroActionTypes.DELETE_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OpinometroActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OpinometroActionTypes.GET_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        opinometro: {},
                        loading: false,
                    };
                }
                case OpinometroActionTypes.LIST_OPINOMETROS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaOpinometros: [],
                        loading: false,
                    };
                }
                case OpinometroActionTypes.ADD_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OpinometroActionTypes.DUPLICATE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OpinometroActionTypes.UPDATE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OpinometroActionTypes.DELETE_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OpinometroActionTypes.GET_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case OpinometroActionTypes.LIST_OPINOMETROS:
            return { ...state, error: false, loading: true };
        case OpinometroActionTypes.ADD_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case OpinometroActionTypes.DUPLICATE_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case OpinometroActionTypes.UPDATE_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case OpinometroActionTypes.DELETE_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case OpinometroActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                opinometro: {},
                listaOpinometros: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Opinometro;
